<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content" style="">
            <!-- tab切换 -->
            <div class=" ">
                <el-tabs v-model="activeName" type="border-card">
                    <el-tab-pane label="国内市场" name="first" :key="'first'">
                        <battleNetUser v-if="activeName === 'first'" />
                    </el-tab-pane>
                    <el-tab-pane label="血液" name="second" :key="'second'">
                        <targetAgainstUserBlood v-if="activeName === 'second'" />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import battleNetUser from './battleNetUser.vue'
import targetAgainstUserBlood from './targetAgainstUserBlood.vue'
export default {
    components: {
        //Breadcrumb,
        battleNetUser,
        targetAgainstUserBlood,
    },
    data() {
        return {
            // 默认第一个Tab
            activeName: "first",
        };

    },
    created() {
        if(this.$route.query.type){
            this.activeName = this.$route.query.type;
        }

    },
    methods: {
        //tab切换
        handleClick(tab) {
        },

    }
}
</script>
<style scoped>
.h-content{
    background: #fff
}
</style>
